import moment from 'moment';

import api from '../../lib/api';
import endpoints from '../../lib/endpoints';

import {
  SEARCH_PARAMS_INIT,
  SEARCH_PARAMS_UPDATE,
  START_FLIGHT_SEARCH,
  SEARCH_RESULTS_INIT,
  FLIGHT_SEARCH_FAILED,
  SELECT_A_FLIGHT,
  CLEAR_SELECTED_FLIGHT,
  STORE_RESERVATION_DETAILS,
  UPDATE_TIMER,
  INIT_PASSENGER_DETAILS,
  UPDATE_PASSENGER_DETAIL,
  STORE_CONTACT_DETAILS,
  CHANGE_FLIGHT_SORTER,
  RESET_FLIGHTS_UI,
  SHOW_RESERVATION_FAILED_MESSAGE,
  STORE_FLIGHTS_PAYMENT_DETATILS,
  BOOK_SELECTED_FLIGHTS,
  // STORE_FLIGHT_BOOKING_ID,
  // STORE_FLIGHTS_BOOKING_PROCESS_ID,
} from './types';

import { trackFlightSearch, trackFlightBookButtonPress } from './analyticsEventActions';

export const initializeFlightSearchParams = ({ searchParams }) => ({
  type: SEARCH_PARAMS_INIT,
  searchParams,
});

export const updateFlightSearchParms = ({ parameter, value }) => ({
  type: SEARCH_PARAMS_UPDATE,
  parameter,
  value,
});

export const searchFlightsWithParams = ({
  from_location,
  to_location,
  departure_date,
  arrival_date,
  trip_type,
  num_adults,
  num_children,
  nationality,
}) => {
  return async (dispatch) => {
    let query = {
      from_location,
      to_location,
      departure_date,
      trip_type,
      num_adults,
      num_children,
      nationality,
    };
    // search only if necessary dates are not empty string
    const beginSearch = () => {
      switch (trip_type) {
        case 'O':
          return departure_date === '' ? false : true;
        case 'R':
          query.arrival_date = arrival_date;
          return departure_date === '' || arrival_date === '' ? false : true;
        default:
          return false;
      }
    };
    if (beginSearch()) {
      dispatch(setSearchingTrue());
      const { data } = await api.postWithoutToken(endpoints.flights.search, query);
      if (data.flights) {
        const {
          flights: { inbound, outbound },
        } = data;
        dispatch(storeFlightSearchResults({ inbound, outbound }));
      } else {
        dispatch(flightSearchFailed());
      }
    }
  };
};

export const searchFlights = () => {
  return async (dispatch, getState) => {
    const { searchParams } = getState().flightsUi;
    dispatch(
      searchFlightsWithParams({
        ...searchParams,
      })
    );
    dispatch(trackFlightSearch({ startDate: searchParams.departure_date }));
  };
};
export const setSearchingTrue = () => ({
  type: START_FLIGHT_SEARCH,
});

export const storeFlightSearchResults = ({ inbound, outbound }) => ({
  type: SEARCH_RESULTS_INIT,
  searchResult: { inbound, outbound },
});

export const changeFlightSorter = ({ sorter }) => ({
  type: CHANGE_FLIGHT_SORTER,
  sorter,
});

export const flightSearchFailed = () => ({ type: FLIGHT_SEARCH_FAILED });

export const selectAFlight = ({ flightType, selectedFlight }) => {
  return {
    type: SELECT_A_FLIGHT,
    flightType,
    selectedFlight,
  };
};

export const clearSelectedFlight = ({ flightType }) => ({
  type: CLEAR_SELECTED_FLIGHT,
  flightType,
});

export const reserveFlights = () => {
  return async (dispatch, getState) => {
    const { searchParams, selectedFlights } = getState().flightsUi;
    const { inbound, outbound } = selectedFlights;
    const { trip_type } = searchParams;
    const flight_id = outbound.flight_id;
    const return_flight_id = trip_type === 'R' ? inbound.flight_id : null;

    let requestObj = { flight_id };
    if (return_flight_id) requestObj.return_flight_id = return_flight_id;

    try {
      const { data } = await api.postWithoutToken('flights/reservation', requestObj);

      if (data.reservation_status === 'OK') {
        dispatch(storeFlightReservationDetails({ reservationDetails: data }));
        dispatch(trackFlightBookButtonPress());
      } else {
        dispatch(showFlightReservationFailedMessage());
      }
    } catch (e) {
      dispatch(showFlightReservationFailedMessage());
    }
  };
};

const showFlightReservationFailedMessage = () => ({
  type: SHOW_RESERVATION_FAILED_MESSAGE,
});

const storeFlightReservationDetails = ({ reservationDetails }) => ({
  type: STORE_RESERVATION_DETAILS,
  reservationDetails: {
    ...reservationDetails,
    reservationStartTime: moment(),
  },
});

export const createPassengerDetailsForms = () => {
  const passengerDetailObj = {
    pax_type: '',
    title: 'Ms',
    first_name: '',
    middle_name: '',
    last_name: '',
    nationality: '',
    remarks: '',
  };
  return (dispatch, getState) => {
    const { num_adults, num_children } = getState().flightsUi.searchParams;
    let adults = Number(num_adults);
    let children = Number(num_children);
    let allIds = [];
    let byId = {};
    let index = 0;
    while (adults > 0) {
      allIds.push(index);
      byId[index] = { ...passengerDetailObj, pax_type: 'Adult' };
      adults--;
      index++;
    }
    while (children > 0) {
      allIds.push(index);
      byId[index] = { ...passengerDetailObj, pax_type: 'Child' };
      children--;
      index++;
    }
    dispatch(
      initPassengerDetails({
        passengerDetails: {
          byId,
          allIds,
        },
      })
    );
  };
};

export const updatePassengerDetail = ({ passengerId, passengerDetail }) => {
  return {
    type: UPDATE_PASSENGER_DETAIL,
    passengerId,
    passengerDetail,
  };
};

export const updateFlightsCountdown = ({ remainingTime }) => ({
  UPDATE_TIMER,
  remainingTime,
});

const initPassengerDetails = ({ passengerDetails }) => ({
  type: INIT_PASSENGER_DETAILS,
  passengerDetails,
});

export const storeContactDetails = ({ contactPerson }) => ({
  type: STORE_CONTACT_DETAILS,
  contactPerson,
});

export const resetFlightsUi = () => ({ type: RESET_FLIGHTS_UI });
export const onBookBtnPress = () => ({ type: BOOK_SELECTED_FLIGHTS });

export const storeFlightsPaymentDetails = paymentDetails => ({
  type: STORE_FLIGHTS_PAYMENT_DETATILS,
  paymentDetails,
});



// WEBPACK FOOTER //
// ./src/redux/actions/FlightsUiActions.js